// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3gGEh","rootSuccess":"CompleteLink_rootSuccess__3u9vn","rootFailure":"CompleteLink_rootFailure__2_MaB","isDisabled":"CompleteLink_isDisabled__1OsuU"};